import firebase_api from '@/firebase/firebase_api'

const object = {
    

    setTerrain(zones, club, tournoi, indexPartie, terrain, zone, state, save) {
        
        if (typeof(zones)!="undefined") {
            var terrainData = zones[zone].terrains[terrain];
            
            if (typeof(terrainData.parties)=="undefined") {
                terrainData.parties = [];
            }
            if (terrainData.parties[indexPartie]==null) {
                terrainData.parties[indexPartie] = {
                    state : state
                }
            }
            else
                terrainData.parties[indexPartie].state = state;
            

            if (save) {
                firebase_api.api.getDb().collection("club").doc(club.id)
                        .collection("tournois").doc(tournoi.id).update({
                            "options.zones": zones
                        })
            }
        }
    },
    setJoueursInTerrain(zones, indexPartie, equipe) {
        if (typeof(equipe.terrain)!="undefined") {
            if (equipe.terrain != null) {
                    var terrain = zones[equipe.terrain.zone].terrains[equipe.terrain.name];
                    if (typeof(terrain.parties)!="undefined")  {
                        if (terrain.parties[indexPartie]!=null)  {
                        terrain.parties[indexPartie].joueurs=[];
                        for (var joueur in equipe.joueurs) {
                            if (equipe.joueurs[joueur]!=null) {
                                terrain.parties[indexPartie].joueurs.push(equipe.joueurs[joueur].numero);
                            }
                        }
                        for (var joueur in equipe.contre) {
                            if (equipe.contre[joueur]!=null) {
                                terrain.parties[indexPartie].joueurs.push(equipe.contre[joueur].numero);
                            }
                        }
                        
                        }
                    }
            }
        }
    },
    reinintStateTerrain(zones, club, tournoi, indexPartie, equipe, save) {
        var state;
        if (typeof(equipe.terrain)!="undefined") {
            if (equipe.terrain != null) {
                if (equipe.state=='WAITING') {
                    state = "BUSY";
                }
                else {
                    state = "SOON";
                }
                
                this.setTerrain(zones, club, tournoi, indexPartie, equipe.terrain.name, equipe.terrain.zone, state, save);
            }
        }
        
    },
    reinitStateTerrainsTournois(zones, indexPartie, club, tournoi, equipes) {
        
        if (typeof(zones)!="undefined")
            if (Object.keys(zones).length>0) {
                    // ICI On réinitialise tout :
                for (var zoneName in zones) {
                    for (var terrainName in zones[zoneName].terrains) {
                            var terrain = zones[zoneName].terrains[terrainName];
                            if (typeof(terrain.parties)=="undefined")
                                terrain.parties=[];
                            terrain.parties[indexPartie]=null;
                        }     
                }
                equipes.forEach((equipe, indiceEquipe)=>{
                    this.reinintStateTerrain(zones, club, tournoi, indexPartie, equipe, false);
                    this.setJoueursInTerrain(zones, indexPartie, equipe);
                })
               
                
                firebase_api.api.getDb().collection("club").doc(club.id)
                    .collection("tournois").doc(tournoi.id).update({
                       "options.zones": zones
                    })
            }
    },
    
    
}




export default {
    object: object
}